import { createAsyncThunk } from '@reduxjs/toolkit';
import paymentModel from '@/models/payment';
import subscriptionModel from '@/models/subscription';
import ResponseError from '@/errors/responseError';
import { fetchBillingInfo, fetchMe } from '../auth/thunks';

export const fetchPayments = createAsyncThunk(
	'billing/fetchPayments',
	async (pageSize, { getState, rejectWithValue }) => {
		try {
			const { page } = getState().billing;

			const params = { ...(page && page > 1 && { page }) };

			return paymentModel.getPayments({ params });
		} catch (error) {
			if (error instanceof ResponseError) {
				return rejectWithValue({ status: error.status, data: error.data });
			}
			throw error;
		}
	}
);

export const cancelSubscription = createAsyncThunk(
	'billing/cancelSubscription',
	async (_, { rejectWithValue, dispatch }) => {
		try {
			await subscriptionModel.cancelSubscription();
			return await dispatch(fetchBillingInfo());
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const reactivateSubscription = createAsyncThunk(
	'billing/reactivateSubscription',
	async (_, { rejectWithValue, dispatch }) => {
		try {
			await subscriptionModel.cancelRollback();
			return await dispatch(fetchBillingInfo());
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);

export const subscribe = createAsyncThunk(
	'billing/subscribe',
	async (
		{ priceId, currency, mainPriceId },
		{ rejectWithValue, dispatch }
	) => {
		try {
			const response = await subscriptionModel.subscribe({
				priceId,
				currency,
				mainPriceId
			});

			await Promise.all([dispatch(fetchMe()), dispatch(fetchBillingInfo())]);

			return response;
		} catch (error) {
			return rejectWithValue(error);
		}
	}
);
